import { render } from "./calendarBox.vue?vue&type=template&id=fbf1a45a"
import script from "./calendarBox.vue?vue&type=script&lang=js"
export * from "./calendarBox.vue?vue&type=script&lang=js"

import "./calendarBox.vue?vue&type=style&index=0&id=fbf1a45a&lang=less"

import exportComponent from "/Users/islibaodong/IdeaProjects/2024/Titan-Frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__